export class LoginRequiredError extends Error {
  readonly code = 401;
}
